import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

import JavaView from '../views/JavaView.vue'
import ClassView from '../views/ClassView.vue'
import CppView from '../views/CppView.vue'
import FaqView from '../views/FAQView.vue'
import CppClassView from '../views/CppClassView.vue'
import PythonCompareView from '../views/PythonCompareView.vue'
import PythonView from '../views/PythonView.vue'
import PythonClassView from '../views/PythonClassView.vue'
import AlgorithmClassView from '@/views/AlgorithmClassView.vue'
import CoderView from '@/views/CoderView.vue'
import CustomView from '@/views/CustomView.vue'
import AlgorithmView from '@/views/AlgorithmView.vue'
import AdvancedClassView from '@/views/AdvancedClassView.vue'
import ApView from '@/views/ApView.vue'
import EntryView from '@/views/EntryView.vue'
import GESPView from '@/views/GESPView.vue'
import CSPJView from '@/views/CSPJView.vue'
import CSPSView from '@/views/CSPSView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/class',
    name: 'class',
    component: ClassView
  },
  {
    path: '/gesp',
    name: 'class',
    component: GESPView
  },
  {
    path: '/csp-j',
    name: 'class',
    component: CSPJView
  },
  {
    path: '/csp-s',
    name: 'class',
    component: CSPSView
  },
  {
    path: '/entry',
    name: 'entry',
    component: EntryView
  },
  {
    path: '/ap',
    name: 'ap',
    component: ApView
  },
  {
    path: '/java',
    name: 'java',
    component: JavaView
  },
  {
    path: '/cpp',
    name: 'cpp',
    component: CppView
  },
  {
    path: '/cppclass',
    name: 'cppclass',
    component: CppClassView
  },
  {
    path: '/faq',
    name: 'faq',
    component: FaqView
  },
  {
    path: '/python',
    name: 'python',
    component: PythonView
  },
  {
    path: '/python-compare',
    name: 'pythonCompare',
    component: PythonCompareView
  }
  ,
  {
    path: '/custom',
    name: 'custom',
    component: CustomView
  }
  ,
  {
    path: '/pythonclass',
    name: 'pythonClass',
    component: PythonClassView
  },
  {
    path: '/algorithm-class',
    name: 'algorithmclass',
    component: AlgorithmClassView
  },
  {
    path: '/algorithm',
    name: 'algorithm',
    component: AlgorithmView
  },
  {
    path: '/online-coding',
    name: 'coder',
    component: CoderView
  },
  {
    path: '/advanced-class',
    name: 'advancedClass',
    component: AdvancedClassView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
